import { ApprovalStatusEnum, COUNTRIES } from '../../../../../common/constants';
import { Base, ControlProperty } from '../../../../../common/models';
import { DraggableFilterType } from '../../../../constants';
import { PartnerServiceType } from './partner-external-ids.constant';

export enum PartnerFormName {
  Details = 'details',
  ExternalIds = 'extIds',
}

export enum PartnerType {
  Carrier = 'CARRIER',
  Customer = 'CUSTOMER',
}

export enum PartnerOnboardingStatus {
  NotOnboarded = 'NOT_ONBOARDED',
  InOnboarding = 'IN_ONBOARDING',
  Onboarded = 'ONBOARDED',
  Manual = 'MANUAL',
}

export enum BooleanData {
  True = 'true',
  False = 'false',
}

export enum PartnerListFilterName {
  ApprovalStatus = 'approvalStatus',
  PartnerActive = 'active',
  PartnerTypeFilter = 'partnerType',
  PartnerName = 'name',
  Country = 'country',
  City = 'city',
  ZipCode = 'zipCode',
  StreetName = 'streetName',
  StreetNumber = 'streetNumber',
  ServiceType = 'serviceType',
  ServiceId = 'serviceId',
  ShortName = 'shortName',
}

export const PARTNER_FILTER_TYPE_BY_NAME: Map<PartnerListFilterName, DraggableFilterType> = new Map([
  [PartnerListFilterName.PartnerTypeFilter, DraggableFilterType.DropDownSelect],
  [PartnerListFilterName.PartnerActive, DraggableFilterType.DropDownSelect],
  [PartnerListFilterName.ServiceType, DraggableFilterType.DropDownSelect],
  [PartnerListFilterName.ShortName, DraggableFilterType.DropDownSearchSelect],
  [PartnerListFilterName.PartnerName, DraggableFilterType.Input],
  [PartnerListFilterName.Country, DraggableFilterType.DropDownSearchSelect],
  [PartnerListFilterName.City, DraggableFilterType.Input],
  [PartnerListFilterName.ZipCode, DraggableFilterType.Input],
  [PartnerListFilterName.StreetName, DraggableFilterType.Input],
  [PartnerListFilterName.StreetNumber, DraggableFilterType.Input],
  [PartnerListFilterName.ServiceId, DraggableFilterType.Input],
]);

export const PARTNER_FILTER_SELECT_OPTIONS_BY_NAME = new Map<PartnerListFilterName, string[] | Base[]>([
  [PartnerListFilterName.PartnerTypeFilter, Object.values(PartnerType)],
  [PartnerListFilterName.ServiceType, Object.values(PartnerServiceType)],
  [PartnerListFilterName.PartnerActive, Object.keys(BooleanData)],
  [PartnerListFilterName.Country, COUNTRIES],
  [PartnerListFilterName.ShortName, []],
]);

export class PartnerListFiltersModelBase {
  [PartnerListFilterName.PartnerTypeFilter]: string = null;
  [PartnerListFilterName.PartnerActive]: boolean = null;
  [PartnerListFilterName.ApprovalStatus]: ApprovalStatusEnum = null;
  [PartnerListFilterName.Country]: string = null;
  [PartnerListFilterName.PartnerName]: string = null;
  [PartnerListFilterName.City]: string = null;
  [PartnerListFilterName.ZipCode]: string = null;
  [PartnerListFilterName.StreetName]: string = null;
  [PartnerListFilterName.StreetNumber]: string = null;
  [PartnerListFilterName.ServiceType]: string = null;
  [PartnerListFilterName.ServiceId]: number = null;
  [PartnerListFilterName.ShortName]: string = null;

  constructor(params?: PartnerListFiltersModelBase) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PartnerListFilterForm {
  constructor(
    model: PartnerListFiltersModelBase,
    public serviceId: ControlProperty<number> = [model.serviceId, []],
    public serviceType: ControlProperty<string> = [model.serviceType, []],
    public streetNumber: ControlProperty<string> = [model.streetNumber, []],
    public streetName: ControlProperty<string> = [model.streetName, []],
    public zipCode: ControlProperty<string> = [model.zipCode, []],
    public city: ControlProperty<string> = [model.city, []],
    public name: ControlProperty<string> = [model.name, []],
    public active: ControlProperty<boolean> = [model.active, []],
    public country: ControlProperty<string> = [model.country, []],
    public approvalStatus: ControlProperty<ApprovalStatusEnum> = [model.approvalStatus, []],
    public partnerType: ControlProperty<string> = [model.partnerType, []],
    public shortName: ControlProperty<string> = [model.shortName, []],
  ) {}
}
